module.exports = __webpack_public_path__ + "img/AT0000002648499.88f9797a.png";